import {internalApi} from "../../common/axios";
import {useQueryBase} from "../../shared/hooks/useHookBase";

const fetchEventTable = async () => {
    const {data} = await internalApi.get('events/table');
    return data.tbl;
}

export const useEventTable = () => {
    return useQueryBase('eventTable', fetchEventTable, {staleTime: 0});
}

// 선행 조건(이벤트 완료)으로 지정한 이벤트가 실제로 그 기간에 편성돼 있는지 확인하는 용도.
const fetchEventSchedule = async () => {
    const {data} = await internalApi.get('events?filters={}');
    return data.rows;
}

export const useEventSchedule = () => {
    return useQueryBase('eventSchedule', fetchEventSchedule, {staleTime: 0});
}
